export const SITE_SHORTCUTS = {
    '/МечтаТут': '6abd21571253717a05cd2ca0',
    // Добавляйте другие ярлыки:
    // '/Работа': 'другой_id_сайта',
    // '/Игры': 'ещё_один_id_сайта',
};